import './components/translate'
import './assets/styles/global-style.css'
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'

import { ChakraProvider } from '@chakra-ui/react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'

import { GlobalStyle } from './assets/styles/global-style'
import {
  breakpoints,
  colors,
  fontSizes as font,
} from './assets/styles/theme-variables'
import Toast from './components/alert/toast'
import theme from './lib/chakra/theme'
import { Main } from './main'
import store from './store'
import { RootProvider } from './store/context/root.context'

function App() {
  React.useEffect(() => {
    const language = localStorage.getItem('language')
    language ? language : localStorage.setItem('language', 'pt-BR')
  }, [])

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_ID as string}>
      <Provider store={store}>
        <ThemeProvider theme={{ colors, breakpoints, font }}>
          <ChakraProvider theme={theme}>
            <GlobalStyle />
            <React.Suspense fallback="">
              <RootProvider>
                <Main />
              </RootProvider>
            </React.Suspense>
            <Toast />
          </ChakraProvider>
        </ThemeProvider>
      </Provider>
    </GoogleOAuthProvider>
  )
}

export default App
